// extracted by mini-css-extract-plugin
export default {"buttonComponent":"buttonComponent_buttonComponent__O3BzK"};